﻿import common from "../../../common";
import HotEditableFormManager_ from "./HotEditableFormManager";
import HotEditableFormAction_ from "./HotEditableFormAction";
// const HotEditableFormManager = require("./HotEditableFormManager") as HotEditableFormManager_;
// const HotEditableFormAction = require("./HotEditableFormAction") as HotEditableFormAction_;

class SharedFormManager {
    private _formManager: HotEditableFormManager_;
    private _actionCallback?: (a: HotEditableFormAction_) => void;
    private _errorCallback?: (errors: common.IError[], config?: common.IHotEditableFormConfig) => void;

    constructor(formManager: HotEditableFormManager_) {
        this._formManager = formManager;
    }

    /** focusFirstFieldOnEdition: default=TRUE */
    setupForm(isEditionAlwaysOn?: boolean, focusFirstFieldOnEdition?: boolean) {
        this._formManager.setupForm(isEditionAlwaysOn, focusFirstFieldOnEdition);
        return this;
    }

    setActionCallback(action: (action: HotEditableFormAction_) => void) {
        this._actionCallback = action || null;
        return this;
    }
    setErrorCallback(action: (errors: common.IError[], config?: common.IHotEditableFormConfig) => void) {
        this._errorCallback = action || null;
        return this;
    }

    setAsHotEditableFormMode() {
        this._formManager.setAsHotEditableFormMode();
        return this;
    }
    /** Retournera TRUE si le champ existe et a ete mis a jour */
    updateConcurrencySumCheck(sumCheck?: string | null) {
        return this._formManager._innerUpdateConcurrencySumCheck(sumCheck);
    }
    hasEditionEmbeddedForm() {
        return this._formManager.hasEditionEmbeddedForm();
    }
    isHotEmbeddedComponent() {
        return this._formManager.isHotEmbeddedComponent();
    }
    getCurrentEmbeddedComponentName() { return this._formManager.getCurrentEmbeddedComponentName(); }
    /** Si 'clause' est NULL, alors TOUT les models seront retournes, sinon, seul ceux dont la clause retourne TRUE seront retournes */
    getEmbeddedContentModels(clause?: (model: common.IEmbeddedContentModel) => boolean) {
        return this._formManager.getEmbeddedContentModels(clause);
    }
    countEmbeddedContentModelsByCategory(category: string) {
        return this._formManager.countEmbeddedContentModelsByCategory(category);
    }
    showEmbeddedContentModelsByCategory(category: string, isVisible?: boolean) {
        this._formManager.showEmbeddedContentModelsByCategory(category, isVisible);
        return this;
    }
    /** Si 'nextUrl' est NULL, alors l'url sera celle definie par DEFAULT */
    updateHotEmbeddedComponent(name: string, nextUrl?: string, urlParameters?: {}, editModeOn?: boolean, finalEvalCallback?: () => void) {
        return this._formManager.updateHotEmbeddedComponent(name, nextUrl, urlParameters, editModeOn, finalEvalCallback);
    }
    /** Si 'nextUrl' est NULL, alors l'url sera celle definie par DEFAULT */
    updateCurrentHotEmbeddedComponent(nextUrl?: string, urlParameters?: {}) {
        this._formManager.updateCurrentHotEmbeddedComponent(nextUrl, urlParameters);
        return this;
    }
    /** Retournera "alsoUpdateCurrent" (bool) */
    updateHotEmbeddedComponents(embeddedForms?: common.IEmbeddedComponentToUpdate[]) {
        return this._formManager.updateHotEmbeddedComponents(embeddedForms);
    }
    hotEmbeddedComponentExists(embeddedForm: common.IEmbeddedComponentToUpdate) {
        return this._formManager.containsHotEmbeddedComponent(embeddedForm.name);
    }
    getEmbeddedContentModelByName(name: string) {
        return this._formManager.getEmbeddedContentModelByName(name);
    }

    refreshBrotherEmbeddedComponents(currentEmbeddedComponentName: string) {
        this._formManager.refreshBrotherEmbeddedComponents(currentEmbeddedComponentName);
        return this;
    }
    getFormName() { return this._formManager.getFormName(); }
    onFormError(errors: common.IError[], config?: common.IHotEditableFormConfig) {
        if (this._errorCallback)
            this._errorCallback(errors, config);
        return this;
    }
    onFormAction(action: HotEditableFormAction_) {
        if (this._actionCallback)
            this._actionCallback(action);
        return this;
    }
    hideAllFieldMessages() {
        this._formManager.autoCloseMessages();
        return this;
    }

    displayFieldError(formName?: string | null, error?: common.IError, focusFirstErrorField?: boolean) {
        return this._formManager.displayFieldError(formName, error, focusFirstErrorField);
    }

    /** Retournera TRUE si le message du champ existe. */
    displayFieldErrors(formName?: string | null, errors?: common.IError[], focusFirstErrorField?: boolean) {
        return this._formManager.displayFieldErrors(formName, errors, focusFirstErrorField);
    }
    /** L'argument 'name' est a la fois RefFieldNames et MessageNames. Retournera TRUE si un MessageComponent (form) a ete mis a jour. */
    displayMessage(name?: string, message?: string, messageType?: common.MessageTypes) {
        return this._formManager.displayMessage(name, message, messageType);
    }
    clearAllFields(excludedFieldNames?: string[]) {
        return this._formManager.clearAllFields(excludedFieldNames);
    }
    clearAllVisibleFields(excludedFieldNames?: string[]) {
        return this._formManager.clearAllFields(excludedFieldNames, true);
    }
    getFormManager() {
        return this._formManager;
    }

    destroyComponentsByNode() {
        this._formManager?.formNode?.destroyComponents();
        return this;
    }
    /* Les proprietes 'isButtonClick' et 'changedFieldName' sont exclusives. */
    applyUpdate(actionValue?: string | null, actionType?: common.HotEditableActionTypes, isButtonClick?: boolean, buttonClickContext?: common.IButtonClickContext, changedFieldName?: string | null) {
        this._formManager.applyUpdate(actionValue, actionType, isButtonClick, buttonClickContext, changedFieldName);
        return this;
    }
    updateFieldFromApi(fieldToUpdate: common.IHotEditableUpdateField, applyChanged?: boolean) {
        if (fieldToUpdate)
            this._formManager.updateFieldFromApi(fieldToUpdate, applyChanged);
        return this;
    }
    /** Retournera TRUE si le champ existe et a ete mis a jour */
    updateField(name?: string, value?: string, valueOptions?: string, disabled?: boolean, applyChanged?: boolean) {
        return this._formManager.updateField(name, value, valueOptions, disabled, applyChanged);
    }
    /** Retournera TRUE si le champ existe et a ete mis a jour */
    disabledField(name: string, value?: boolean) {
        return this._formManager.disabledField(name, value);
    }
    revertLastChanges() {
        return this._formManager.revertLastChanges();
    }
    confirmationRejected() {
        return this._formManager.confirmationRejected();
    }
}

export = SharedFormManager;